// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2e4Pl","footerInner":"style_footerInner__r-qGT","logo":"style_logo__1NWVM"};